import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
  redirect,
  Scripts,
} from '@tanstack/react-router';
import { Suspense } from 'react';

import { Layout } from '@mint-emails/recommendation/routes';
import { type RouterContext } from '@mint-lib/routing-context';

import { TanStackRouterDevtools } from '../components/DevTools.js';

export const Route = createRootRouteWithContext<RouterContext>()({
  beforeLoad: ({ location }) => {
    if (!location.pathname.includes('/recommendation')) {
      throw redirect({
        to: '/recommendation' + location.pathname,
        search: location.search,
      });
    }
  },
  component: Root,
  head: () => ({
    meta: [{ title: 'MINT - Emails' }],
  }),
  loader: async (props) => {
    await props.context.getInstance('http', 'guestApi');
  },
});

function Root() {
  return (
    <>
      <HeadContent />
      <Layout>
        <Outlet />
      </Layout>
      <Suspense>
        <TanStackRouterDevtools />
      </Suspense>
      <Scripts />
    </>
  );
}
